import type { VendorMetadataExtractor } from './types'
import { extractEmbeddedGps } from './embedded-gps'

export const genericExtractor: VendorMetadataExtractor = {
  vendorId: null,
  vendorLabel: 'Generic / Other',
  supportsDirectoryBrowse: false,

  // NMEA text in known MP4 boxes, or an ISO 6709 phone location tag. No GPS: null, so the file date baseline stays.
  extractFromFiles: extractEmbeddedGps
}
